export const textfieldTokens = {
  textfield: {
    searchIcon: {
      background: '{formField.background}'
    },
    searchButton: {
      color: '{primary.color}',
      background: '{info.background}',
      borderRadius: '{borderRadius.sm}'
    },
    filterMenu: {
      background: '{surface.0}',
      borderColor: '{formField.borderColor}',
      borderRadius: '{borderRadius.sm}',
      shadow: '0 4px 18px 0 rgba(53, 67, 88, 0.08)',
      itemBackground: '{info.background}',
      itemBorderRadius: '{borderRadius.sm}',
      dividerColor: '{surface.300}'
    }
  }
};

export type TextFieldTokens = typeof textfieldTokens;
